<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div id="user-edit-tab-info">
    <div class="location-add-header">
      <h3>
        {{ data_local && data_local.AttendeeId ? "Edit User" : "Add New User" }}
      </h3>
      <vs-button radius color="#000" type="flat" class="close-user-pop"
        ><feather-icon
          icon="XIcon"
          svgClasses="h-8 w-8"
          class=""
          @click="cancelAddAttendee"
      /></vs-button>
    </div>
    <!-- Avatar Row -->
    <div class="popup-inner-section">
      <div class="vx-row">
        <div class="vx-col md:w-7/12 w-full mt-2 border-right-sec">
          <div class="checkin-add-form-location">
            <div class="common-add-form mt-2">
              <p>Access Type <span class="rqrd">*</span></p>
              <div class="mt-3">
                <ul class="centerx flex justify-start items-start">
                  <li>
                    <vs-radio
                      v-model="accessType"
                      color="#00ccfe"
                      vs-value="Employee"
                      class="mr-5"
                      >Employee</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      v-model="accessType"
                      color="#00ccfe"
                      vs-value="Management"
                      class="mr-5"
                      >Management</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="common-add-form mt-2">
              <div class="flex justify-start item-center">
                <label>Allow Private CheckIn <span class="rqrd">*</span></label>

                <div class="popup-single-upload-right">
                  <div class="info-option-wrapper">
                    <feather-icon
                      class="h-5 w-5 ml-2"
                      icon="InfoIcon"
                      title="Info Icon"
                    />

                    <div
                      class="popup-info-tooltips user-name-popup"
                      style="height: 100px !important"
                    >
                      <p>
                        Yes means user will be able to do private checkin, no
                        means then user will be able to do self / group checkin
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3">
                <ul
                  class="centerx flex justify-end items-start flex-row-reverse"
                >
                  <li>
                    <vs-radio
                      v-model="allowRemoteCheckin"
                      color="#00ccfe"
                      vs-value="No"
                      class="mr-5"
                      >No</vs-radio
                    >
                  </li>

                  <li>
                    <vs-radio
                      v-model="allowRemoteCheckin"
                      color="#00ccfe"
                      vs-value="Yes"
                      class="mr-5"
                      >Yes</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="common-add-form mt-2">
              <label>First Name<span class="rqrd">*</span></label>
              <!-- <input type="text" name="" id="" placeholder="First Name" /> -->
              <vs-input
                autocomplete="off"
                class="w-full"
                type="text"
                name="FirstName"
                placeholder="First Name*"
                v-model="data_local.FirstName"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('FirstName')"
                >{{ errors.first("FirstName") }}</span
              >
            </div>
            <div class="common-add-form">
              <label>Last Name<span class="rqrd">*</span></label>
              <!-- <input type="text" name="" id="" placeholder="Last Name" /> -->
              <vs-input
                autocomplete="off"
                class="w-full"
                type="text"
                name="LastName"
                placeholder="Last Name"
                v-model="data_local.LastName"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('LastName')"
                >{{ errors.first("LastName") }}</span
              >
            </div>
            <div class="common-add-form">
              <div class="flex justify-start item-center">
                <label>User Name<span class="rqrd">*</span></label>

                <div class="popup-single-upload-right">
                  <div class="info-option-wrapper">
                    <feather-icon
                      class="h-5 w-5 ml-2"
                      icon="InfoIcon"
                      title="Info Icon"
                    />

                    <div class="popup-info-tooltips user-name-popup">
                      <p>Username once given cannot be changed later on</p>
                    </div>
                  </div>
                </div>
              </div>

              <vs-input
                autocomplete="off"
                class="w-full"
                type="text"
                name="Username"
                placeholder="User Name"
                :readonly="emailFieldReadOnly"
                v-model="data_local.Username"
                maxlength="16"
                v-validate="'required|alpha_num|min:6|max:16'"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Username')"
                >{{ errors.first("Username") }}</span
              >
            </div>
            <!-- <div class="common-add-form">
              <label>Email<span class="rqrd">*</span></label>
              <vs-input
                autocomplete="off"
                class="w-full"
                type="email"
                name="Email"
                placeholder="Email*"
                :readonly="emailFieldReadOnly"
                v-model="data_local.Email"
                v-validate="'required|email'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Email')">{{
                errors.first("Email")
              }}</span>
            </div> -->
            <div class="common-add-form">
              <label>Domain Area </label>
              <vs-input
                autocomplete="off"
                class="w-full"
                type="text"
                name="DomainArea"
                placeholder="Add Domain Area "
                v-model="data_local.DomainArea"
              />
            </div>
            <div class="common-add-form">
              <label>Job Title </label>
              <vs-input
                autocomplete="off"
                class="w-full"
                type="text"
                name="Designation"
                placeholder="Job Title"
                v-model="data_local.Designation"
                style="display: none"
              />
              <v-select
                :closeOnSelect="true"
                v-model="selectedDesignation"
                :options="designationList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                label="Name"
              >
                <template v-slot:option="option">
                  {{ option.Name }}
                </template>
              </v-select>
            </div>

            <div class="checkin-add-form-location assign-role px-0">
              <label>Assign Role</label><br />
              <vue-multi-select
                ref="multiSelectRoles"
                :key="rolesKey"
                v-model="selectedCheckinRoles"
                :filters="filters"
                :options="options"
                :selectOptions="checkinRoleList"
                :btnLabel="btnLabelRoles"
                position="top-left"
                :close-on-select="false"
                groupSelect="false"
              >
                <template v-slot:option="{ option }">
                  <div
                    style="
                      width: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                    "
                  >
                    <div>
                      <input type="checkbox" :checked="option.selected" />
                      <span>{{ option.Name }}</span>
                      <!-- <span
                        >{{ option.Name }}-{{ option.RoleId }}<br />{{
                          data_local.DefaultCheckinRole
                        }}</span
                      > -->
                      <!-- <span>{{ option.IsDefault }}</span> -->
                    </div>
                    <div
                      v-if="option.selected"
                      style="width: 100px; padding-right: 5px; color: #fff"
                      @click.stop="refreshPrimaryRole(option.RoleId)"
                    >
                      <label
                        :style="
                          selectedCheckinRoles.includes(
                            data_local.DefaultCheckinRole
                          )
                            ? 'color:#fff;'
                            : 'color:#fff;'
                        "
                      >
                        <input
                          type="radio"
                          name="CheckinRole"
                          :value="option.RoleId"
                          v-model="data_local.DefaultCheckinRole"
                          style="display: none"
                        />
                        <!-- Primary -->
                        <!-- {{option.Primary}} -->
                        {{
                          data_local.DefaultCheckinRole == option.RoleId
                            ? "Primary"
                            : "Make It Primary"
                        }}
                      </label>
                    </div>
                    <!-- <div
                      v-if="option.selected"
                      style="width: 100px; padding-right: 5px; color: #fff"
                    >
                      <div
                        v-if="option.RoleId == data_local.DefaultCheckinRole"
                        @click.self="data_local.DefaultCheckinRole = ''"
                      >
                        Primary
                      </div>
                      <div
                        v-else
                        @click.self="
                          data_local.DefaultCheckinRole = option.RoleId
                        "
                      >
                        Make It Primary
                      </div>
                    </div> -->
                  </div>
                </template>
              </vue-multi-select>
            </div>

            <div class="checkin-add-form-location px-0">
              <label>Select Location </label><br />
              <!-- {{ data_local.DefaultCheckinRole }} -->
              <vue-multi-select
                ref="multiSelectLocations"
                v-model="selectedLocations"
                :options="options"
                :selectOptions="locationList"
                :btnLabel="btnLabelLocations"
                position="top-left"
              >
                <template v-slot:option="{ option }">
                  <input type="checkbox" :checked="option.selected" />
                  <span>{{ option.Name }}</span>
                </template>
              </vue-multi-select>
            </div>
            <div>
              <label>Base Lab</label>
              <vs-input
                autocomplete="off"
                class="w-full"
                type="text"
                name="BaseLab"
                placeholder="Base Lab"
                v-model="data_local.BaseLab"
              />
            </div>
          </div>
          <div>
            <!-- <vue-multi-select
              v-model="data_local.CheckinRoles"
              search
              historyButton
              :filters="filters"
              :options="options"
              :selectOptions="checkinRoleList"
            /> -->

            <!-- <v-select
              multiple
              taggable
              push-tags
              name="CheckinRoles"
              :closeOnSelect="false"
              v-model="data_local.CheckinRoles"
              :options="checkinRoleList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              label="Name"
              :reduce="(item) => item.RoleId"
            >
              <template #option="{ Name, Color }">
                <div style="background: #fff">
                  <h3 style="margin: 0">
                    <input
                      id="selected"
                      v-model="selected"
                      type="checkbox"
                      :true-value="trueValue"
                      :false-value="falseValue"
                    />{{ Name }}
                  </h3>
                  <em>{{ Color }}</em>
                </div>
              </template>
            </v-select> -->
          </div>
          <div class="checkin-add-form-location">
            <!-- <v-select
              multiple
              name="CheckinLocations"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              :closeOnSelect="false"
              v-model="data_local.MappedLocations"
              :options="locationList"
              :reduce="(item) => item.LocationId"
              label="Name"
            > -->
            <!-- <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="toggle">
                  <v-list-item-action>
                    <v-icon
                      :color="data_local.MappedLocations.length > 0 ? 'indigo darken-4' : ''"
                    >
                      {{ icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> Select All </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:append-item>
                <v-divider class="mb-2"></v-divider>
                {{ icon }}
                <v-list-item disabled>
                  <v-list-item-avatar color="grey lighten-3">
                    <v-icon> mdi-food-apple </v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content v-if="likesAllFruit">
                    <v-list-item-title>
                      Holy smokes, someone call the fruit police!
                    </v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-content v-else-if="likesSomeFruit">
                    <v-list-item-title> Fruit Count </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ data_local.MappedLocations.length }}
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-content v-else>
                    <v-list-item-title>
                      How could you not like fruit?
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Go ahead, make a selection above!
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template> -->
            <!-- </v-select> -->
          </div>
        </div>
        <div class="vx-col md:w-5/12 w-full mt-2">
          <!-- <div class="image-wrap-area border-1">
              <div class="flex items-center flex-col sm:flex-row">
                <img :src="imgSrc" class="mr-6 rounded h-24 w-24" />
                <div>
                  <input
                    id="uploadAvatar"
                    type="file"
                    class="hidden"
                    ref="update_avatar_input"
                    @change="update_avatar"
                    accept="image/*"
                  />

                  <vs-button class="" @click="$refs.update_avatar_input.click()"
                    >Upload</vs-button
                  >               
                </div>
              </div>
              <p class="mb-0 mt-2">High quality image: 200x200px (1:1 ratio)</p>
            </div> -->
          <div class="location_image_upload">
            <div class="Location-image-area">
              <feather-icon
                v-show="!imgSrc"
                icon="UserIcon"
                svgClasses="h-12 w-12"
                @click="openFileUpload"
              />
              <img v-show="imgSrc" :src="imgSrc" class="" />
            </div>
            <h4>Upload to add<br />user image</h4>
            <p>Image should be 1:1 ratio in JPG, PNG<br />Max file size 1MB</p>
            <div class="choosefile-button">
              <input
                id="uploadAvatar"
                type="file"
                class="hidden"
                ref="update_avatar_input"
                @change="update_avatar($event, '200x200')"
                accept="image/*"
              />
              <p @click="openFileUpload">Choose File</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-center align-center mt-8">
      <vs-button
        @click="cancelAddAttendee"
        color="#d1d3d7"
        type="border"
        class="cancel-line-button mr-2"
        >CANCEL</vs-button
      >
      <vs-button
        @click="before_save"
        color="#00ccfe"
        type="filled"
        class="add-line-button"
        >{{ data_local.AttendeeId ? "UPDATE" : "ADD" }}</vs-button
      >
    </div>
    <!-- Content Row -->
    <vs-popup
      v-if="false"
      class="holamundo"
      title="Login URL"
      :active.sync="popupActive"
    >
      <div class="vx-row">
        <div class="vx-col md:w-9/12 mt-4">
          <vs-input class="w-full" id="LoginURL" v-model="LoginURL" />
        </div>
        <div class="vx-col md:w-2/12 mt-4">
          <vs-button
            color="dark"
            type="filled"
            @click.stop.prevent="copyLoginUrl"
            >Copy</vs-button
          >
        </div>
      </div>
    </vs-popup>
    <vs-popup
      v-if="false"
      class="holamundo customnewpopup"
      :title="`${
        ticket_data && ticket_data.RegistrationTypeId ? 'Edit' : 'Add'
      } Registration Type`"
      :active.sync="popupTicketPopup"
    >
      <vx-card v-if="ticket_data">
        <ticket-edit-tab-info
          :data="ticket_data"
          v-on:reloadGrid="reloadGrid"
        />
      </vx-card>
    </vs-popup>
    <vs-popup
      class="holamundo registrationType-popup"
      title="Crop Image"
      :active.sync="popupCropper"
      v-if="cropImageUrl"
      style="z-index: 53001"
    >
      <h5>
        Aspect Ratio for this image is {{ displayImageRatio }}. To crop this
        image, simply drag and click Upload
      </h5>
      <photowall-resize-component
        :key="resetCropper"
        v-bind:aspectValue="imageRatio"
        :sourceImage="cropImageUrl"
        @croppedImagePath="croppedImagePath"
      />
    </vs-popup>
  </div>
</template>

<script>
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import CountryDB from "@/assets/CountryList.ts";
import InputTag from "vue-input-tag";
import Swal from "sweetalert2";
import CKEditor from "ckeditor4-vue";
import CKconfig from "@/assets/ckeditor-config.ts";
import vueMultiSelect from "vue-multi-select";
import "vue-multi-select/dist/lib/vue-multi-select.css";
import con from "@/firebase/firebaseInit.ts";

import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import PhotowallResizeComponent from "../photowall/PhotowallResizeComponent.vue";
import moduleTicketManagement from "@/store/ticket-management/moduleTicketManagement.js";
import TicketEditTabInfo from "@/views/ticket/TicketEditTabInfo.vue";
import ClickOutside from "vue-click-outside";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";

var vm;
export default {
  components: {
    VuePhoneNumberInput,
    vSelect,
    vueMultiSelect,
    quillEditor,
    InputTag,
    ckeditor: CKEditor.component,
    PhotowallResizeComponent,
    TicketEditTabInfo,
  },
  props: {
    data_local: {
      type: Object,
      default: () => {},
      required: true,
    },
    locationList: {
      type: Array,
      default: () => [],
      required: true,
    },
    checkinRoleList: {
      type: Array,
      default: () => [],
      required: true,
    },
    designationList: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      filters: [
        {
          nameAll: "Select all",
          nameNotAll: "Deselect all",
          func() {
            return true;
          },
        },
      ],
      options: {
        multi: true,
        groups: false,
        labelName: "Name",
        // labelList: "elements",
        // groupName: "title",
        cssSelected: (option) =>
          option.selected ? { "background-color": "#5764c6" } : "",
      },
      //selected: false,
      trueValue: true,
      falseValue: false,
      selectedLocations: [],
      selectedCheckinRoles: [],
      selectedDesignation: null,
      rolesKey: 0,
      accessType: "Employee",
      allowRemoteCheckin: "No",
      //data_local: JSON.parse(JSON.stringify(this.data)),
      // imgSrc: this.data_local.ProfilePictureURL
      //   ? this.data_local.ProfilePictureURL
      //   : "",
      imgSrc:
        this.data_local.ProfilePictureURL == "" ||
        this.data_local.ProfilePictureURL == undefined
          ? ""
          : this.data_local.ProfilePictureURL,
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      AttendeeId: this.$route.params.AttendeeId
        ? this.$route.params.AttendeeId
        : null,
      countries: CountryDB.CountryList.map(function (item) {
        return item["name"].replace(/[^a-zA-Z ]/g, "");
      }),
      content: ` `,
      emailFieldReadOnly: false,
      popupActive: false,
      LoginURL: null,
      RegistrationTypes: [],
      editorConfig: CKconfig.editorConfig,
      popupTicketPopup: false,
      ticket_data: null,
      imageRatio: 1 / 1,
      cropImageUrl: null,
      resetCropper: 0,
      displayImageRatio: "1:1",
      popupCropper: false,
      showHideFullName: false,
      generateUsername: true,
      con: con,
    };
  },
  computed: {
    likesAllFruit() {
      return vm.data_local.MappedLocations.length === vm.locationList.length;
    },
    likesSomeFruit() {
      return vm.data_local.MappedLocations.length > 0 && !vm.likesAllFruit;
    },
    icon() {
      if (vm.likesAllFruit) return "mdi-close-box";
      if (vm.likesSomeFruit) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    // imgSrc: function () {
    //   if (this.data_local.ProfilePictureURL != null) {
    //     return this.data_local.ProfilePictureURL;
    //   } else {
    //     return "";
    //   }
    // },
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status,
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      },
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role,
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      },
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  watch: {
    selectedDesignation(val) {
      if (val) {
        vm.data_local.Designation = val.Name;
      } else {
        vm.data_local.Designation = "";
      }
    },
    "data_local.FirstName"() {
      //if (!vm.data_local.Username) {
      //if (!vm.data_local.AttendeeId) {
      if (vm.generateUsername) {
        //alert("" + val);
        var username = (vm.data_local.FirstName + vm.data_local.LastName)
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]/gi, "");
        vm.data_local.Username = username.substr(0, 16);
      }
    },
    "data_local.LastName"() {
      //if (!vm.data_local.Username) {
      //if (!vm.data_local.AttendeeId) {
      if (vm.generateUsername) {
        //alert("" + val);
        var username = (vm.data_local.FirstName + vm.data_local.LastName)
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]/gi, "");
        vm.data_local.Username = username.substr(0, 16);
      }
    },
    selectedCheckinRoles() {
      // debugger
      // if (vm.data_local.DefaultCheckinRole && !vm.selectedCheckinRoles.includes(vm.data_local.DefaultCheckinRole)) {
      //   vm.data_local.DefaultCheckinRole = "";
      //   //alert("aaaaaaaaaaaa")
      // }
    },
    "data_local.DefaultCheckinRole": function () {
      // alert("aa");
    },
  },
  methods: {
    refreshPrimaryRole(val) {
      //alert("aaaaaaaaaaa");
      if (
        vm.data_local.DefaultCheckinRole &&
        vm.data_local.DefaultCheckinRole == val
      ) {
        vm.data_local.DefaultCheckinRole = "";
      } else {
        vm.data_local.DefaultCheckinRole = val;
      }
      vm.rolesKey++;
    },
    refreshPrimaryRole1() {
      alert("aaaaaaaaaaa1");
    },
    openFileUpload() {
      $("#uploadAvatar").click();
    },
    btnLabelRoles() {
      var result = "";
      if (this.selectedCheckinRoles.length == 0) {
        result = "Select Roles";
      } else if (this.selectedCheckinRoles.length == 1) {
        result = this.selectedCheckinRoles[0].Name; //"1 Role selected";
        //result = getRoleNameById(this.selectedCheckinRoles[0].RoleId); //"1 Role selected";
      } else {
        result = `${this.selectedCheckinRoles.length} Roles selected`;
      }
      return result;
    },
    btnLabelLocations() {
      var result = "";
      if (this.selectedLocations.length == 0) {
        result = "Select Locations";
      } else if (this.selectedLocations.length == 1) {
        result = this.selectedLocations[0].Name;
      } else {
        result = `${this.selectedLocations.length} Locations selected`;
      }
      return result;
    },
    getRoleNameById(id) {
      var result = "";
      for (var i = 0; i < checkinRoleList.length; i++) {
        if ((checkinRoleList[i].RoleId = id)) {
          result = checkinRoleList[i].Name;
          break;
        }
      }
      return result;
    },
    withPopper(dropdownList, component, { width }) {
      /**
       * We need to explicitly define the dropdown width since
       * it is usually inherited from the parent with CSS.
       */
      dropdownList.style.width = width;

      /**
       * Here we position the dropdownList relative to the $refs.toggle Element.
       *
       * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
       * the dropdownList overlap by 1 pixel.
       *
       * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
       * wrapper so that we can set some styles for when the dropdown is placed
       * above.
       */
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        selected: this.selected,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -1],
            },
          },
          {
            name: "toggleClass",
            enabled: true,
            phase: "write",
            fn({ state }) {
              component.$el.classList.toggle(
                "drop-up",
                state.selected === true
              );
            },
          },
        ],
      });

      /**
       * To prevent memory leaks Popper needs to be destroyed.
       * If you return function, it will be called just before dropdown is removed from DOM.
       */
      return () => popper.destroy();
    },
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedFruits = [];
        } else {
          this.selectedFruits = this.fruits.slice();
        }
      });
    },
    setPhoneCode(data) {
      if (data && data.formattedNumber) {
        this.data_local.Phone = data.nationalNumber;
        this.data_local.PhoneCountryCode = data.countryCode;
      }
    },
    toggleFullName() {
      if (this.data_local.FirstName == "" && this.data_local.LastName == "") {
        this.data_local.Name = "";
      } else {
        this.data_local.Name =
          this.data_local.FirstName + " " + this.data_local.LastName;
      }

      this.showHideFullName = true;
    },
    hideFullName() {
      if (this.data_local.FirstName == "" && this.data_local.LastName == "") {
        this.data_local.Name = "";
      } else {
        this.data_local.Name =
          this.data_local.FirstName + " " + this.data_local.LastName;
      }

      this.showHideFullName = false;
    },
    croppedImagePath(blob) {
      this.imgSrc = blob;
      this.popupCropper = false;
    },
    reloadGrid() {
      this.popupTicketPopup = false;
      this.ticket_data = null;
      this.registrationTypes();
    },
    fetch_ticket_data(RegistrationTypeId) {
      this.ticket_data = null;
      this.$vs.loading();
      this.$store
        .dispatch("TicketManagement/fetchRegistrationType", RegistrationTypeId)
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.RegistrationTypeId) {
            this.ticket_data = res.data;
            this.popupTicketPopup = true;
          } else if (RegistrationTypeId == null) {
            this.ticket_data = res.data;
            this.popupTicketPopup = true;
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Ticket",
              text: "Registartion Type not found in Registartion JSON!",
            });
          }
        });
    },
    copyLoginUrl() {
      /* Get the text field */
      var copyText = document.getElementById("LoginURL");

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");

      /* Alert the copied text */
      this.$vs.notify({
        position: "top-center",
        color: "success",
        //title: "Clip",
        text: "Login URL copied to clipboard",
      });
    },
    capitalize(str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
    },
    cancelAddAttendee() {
      this.$emit("cancelAddAttendee");
    },
    before_save(form_continue = false) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes(form_continue);
        }
      });
    },
    save_changes(form_continue = false) {
      console.log("accessType====", this.accessType);

      /* eslint-disable */
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"
      this.$vs.loading();
      /* eslint-enable */
      this.data_local.ProfilePictureURL = this.imgSrc;

      if (this.con.autoEmailDomainPrefix && this.data_local.Username) {
        this.data_local.Email =
          this.data_local.Username + this.con.autoEmailDomainPrefix;
      }

      if (this.accessType) {
        this.data_local.RegistrationType = {
          RegistrationType: this.accessType,
          RegistrationTypeId: this.accessType == "Management" ? 3 : 10,
          ColorCode: "",
        };
      }
      if (this.allowRemoteCheckin) {
        this.data_local.AllowRemoteCheckin =
          this.allowRemoteCheckin == "No" ? false : true;
      }

      const Id = this.data_local.AttendeeId;
      var vm = this;
      vm.data_local.CheckinRoles = [];
      vm.selectedCheckinRoles.map(function (item) {
        vm.data_local.CheckinRoles.push(item.RoleId);
      });
      vm.data_local.MappedLocations = [];
      vm.selectedLocations.map(function (item) {
        vm.data_local.MappedLocations.push(item.LocationId);
      });
      vm.data_local.DesignationId = "";
      if (vm.selectedDesignation != null) {
        vm.data_local.DesignationId = vm.selectedDesignation.DesignationId;
      }

      console.log("final data====", vm.data_local);

      if (Id) {
        this.$store
          .dispatch("attendeeManagement/updateAttendee", {
            id: Id,
            data: this.data_local,
          })
          .then((res) => {
            this.$vs.notify({
              position: "top-center",
              color: "success",
              title: vm.enableCheckinModule
                ? vm.$t("Attendees")
                : vm.$t("Attendees"),
              text: vm.enableCheckinModule
                ? vm.$t("AttendeeUpdateSuccess")
                : vm.$t("AttendeeUpdateSuccess"),
            });
            // this.$vs.notify({
            //   time: 5000,
            //   position: "top-right",
            //   color: "dark",
            //   title: "Next Steps...",
            //   text: "Use the Mail Attendee option to send login credentials",
            // });
            this.$vs.loading.close();
            this.$emit("saveAttendeeSuccess", 1);
            // if (form_continue) this.$emit("activateTab", 1);
            // else this.$router.push("/event/attendees/");
          })
          .catch((err) => {
            this.$vs.loading.close();
            console.error(err);
          });
      } else {
        this.$store
          .dispatch("attendeeManagement/addAttendeeExt", {
            data: this.data_local,
            enableCheckinModule: vm.enableCheckinModule,
          })
          .then((res) => {
            //console.log("res-----", res);
            debugger;
            if (res.status == 500) {
              this.$vs.notify({
                color: "danger",
                title: "Attendee",
                text: res.message,
              });
              this.$vs.loading.close();
            }
            if (res.status == 200) {
              this.$vs.notify({
                color: "success",
                title: vm.enableCheckinModule
                  ? vm.$t("Attendees")
                  : vm.$t("Attendees"),
                text: vm.enableCheckinModule
                  ? vm.$t("AttendeeAddedSuccess")
                  : vm.$t("AttendeeAddedSuccess"),
              });

              // this.$vs.notify({
              //   time: 5000,
              //   position: "top-right",
              //   color: "dark",
              //   title: "Next Steps...",
              //   text: "Use the Mail Attendee option to send login credentials",
              // });
              this.$vs.loading.close();
              this.$emit("saveAttendeeSuccess", 0);
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
            //console.error(err)
          });
      }
    },
    reset_data() {
      document.getElementById("uploadAvatar").value = "";
      //this.data_local = this.data;
      this.imgSrc =
        this.data_local.ProfilePictureURL == "" ||
        this.data_local.ProfilePictureURL == undefined
          ? require("@/assets/images/default_avatar.jpg")
          : this.data_local.ProfilePictureURL;
    },
    update_avatar(input, fileWH) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        this.data_local.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.resetCropper += 1;
          this.cropImageUrl = null;
          this.cropImageUrl = e.target.result;
          this.popupCropper = true;
          //this.imgSrc = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    getLoginUrl() {
      let vs = this.$vs;
      let vm = this;
      vs.loading();
      let email = this.data_local.Email;
      let password = this.data_local.Password;
      this.$store
        .dispatch("userManagement/getFirebaseAuth", {
          email: email,
          password: password,
        })
        .then(function (response) {
          vs.loading.close();
          vm.LoginURL = response;
          vm.popupActive = true;
        });
    },
    registrationTypes() {
      this.$vs.loading();
      this.$store
        .dispatch("TicketManagement/fetchRegistrationTypes")
        .then((res) => {
          this.RegistrationTypes = res.map((item) => {
            return {
              RegistrationTypeId: item.RegistrationTypeId,
              RegistrationType: item.RegistrationType,
              ColorCode: item.ColorCode,
            };
          });
          this.$vs.loading.close();
        });
    },
    openResetPasswordModal(userId) {
      const { value: text } = Swal.fire({
        title: "Enter the Password you want to set for the User",
        input: "password",
        inputPlaceholder: "Enter 6-16 digit Password and hit the Submit button",
        showCancelButton: true,
        confirmButtonText: "Submit",
        inputValidator: (value) => {
          this.$store
            .dispatch("attendeeManagement/resetPasswordForUser", {
              userId: userId,
              password: value,
            })
            .then((res) => {
              this.$vs.notify({
                position: "top-center",
                color: "success",
                title: "Attendee",
                text: "Attendee Password updated successfully.",
              });
            })
            .catch((err) => {
              console.error(err);
            });
        },
      }).then(function (result) {});
    },
  },
  mounted() {
    var vm = this;
    if (vm.data_local.AttendeeId) {
      this.emailFieldReadOnly = true;
    }
    //vm.data_local.DefaultCheckinRole = "445uBqzZXyl15kcj2dwt";
    if (vm.data_local.CheckinRoles) {
      vm.checkinRoleList.map(function (item) {
        if (vm.data_local.CheckinRoles.includes(item.RoleId)) {
          //vm.data_local.DefaultCheckinRole = item.RoleId;
          vm.selectedCheckinRoles.push(item);
        }
      });
    }
    vm.locationList.map(function (item) {
      if (vm.data_local.MappedLocations.includes(item.LocationId)) {
        vm.selectedLocations.push(item);
      }
    });
    if (vm.data_local.AttendeeId && vm.data_local.Username) {
      vm.generateUsername = false;
    }
    if (
      vm.data_local.AttendeeId &&
      vm.data_local.RegistrationType &&
      vm.data_local.RegistrationType.RegistrationTypeId
    ) {
      vm.accessType = vm.data_local.RegistrationType.RegistrationType;
      vm.allowRemoteCheckin =
        vm.data_local.AllowRemoteCheckin == true ? "Yes" : "No";
    }
    debugger;
    if (vm.data_local.DesignationId) {
      vm.designationList.map(function (item) {
        if (vm.data_local.DesignationId == item.DesignationId) {
          vm.selectedDesignation = item;
        }
      });
    }else{
      vm.designationList.map(function (item) {
        if (vm.data_local.Designation == item.Name) {
          vm.selectedDesignation = item;
        }
      });
    }
  },
  created() {
    vm = this;
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule("userManagement", moduleUserManagement);
      moduleUserManagement.isRegistered = true;
    }
    if (!moduleTicketManagement.isRegistered) {
      this.$store.registerModule("TicketManagement", moduleTicketManagement);
      moduleTicketManagement.isRegistered = true;
    }
    this.registrationTypes();
  },
};
</script>

<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-selected="true"] {
  border-radius: 4px 4px 0 0;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
.popup-info-tooltips.user-name-popup {
  left: 100%;
  height: 60px;
  width: 250px;
  bottom: 50%;
  top: auto !important;
  transform: translateY(50%);
  margin-left: 8px;
}
.popup-info-tooltips.user-name-popup p {
  line-height: 20px;
}
</style>